import { defineMessages } from 'react-intl';

export default defineMessages({
  delivery: {
    id: 'common.titles.delivery',
    defaultMessage: 'Delivery',
  },
  payment: {
    id: 'common.titles.payment',
    defaultMessage: 'Payment',
  },
  billingAddress: {
    id: 'common.titles.billingAddress',
    defaultMessage: 'Billing address',
  },
  shippingAddress: {
    id: 'common.titles.shippingAddress',
    defaultMessage: 'Shipping address',
  },
});
